import moment from 'moment'

class ProductionDetailsFormatter {
  constructor(){}

  prepareForCsvExport(monthlyProductionRecords) {
    const records = _(monthlyProductionRecords)
                      .map(this.toSimplifiedData)
                      .sortBy('yearAndMonth')
                      .value()

    const headers = _(records)
                      .map(this.toKeys)
                      .flatten()
                      .uniq()
                      .without('$$hashKey')
                      .map(this.toStartCase)
                      .value()

    return {
      records: records,
      headers: headers
    }
  }

  toSimplifiedData(record) {
    const parsedYearMonth = [record.date.year, '/', record.date.monthNum].join('')
    return {
      yearAndMonth         : parsedYearMonth,
      leaseUnitId          : record.leaseUnitId,
      gasProductionVolume  : record.gasProductionVolume,
      oilProductionVolume  : record.oilProductionVolume,
      waterProductionVolume: record.waterProductionVolume
    }
  }

  parseMonthYear(record) {
    const date = moment(record.yearMonth)

    record.date = {
      year    : date.format("YYYY"),
      month   : date.format("MMM"),
      monthNum: parseInt(date.format("M"), 10)
    }
    return record
  }

  toKeys(record) {
    return _.keys(record)
  }

  toStartCase(headerName) {
    return _.startCase(headerName)
  }

  track(eventType) {
    this.$analytics.eventTrack(
      'Export Button Interaction',
      {eventType: eventType}
    )
  }
}

ProductionDetailsFormatter.$inject = []

export default ProductionDetailsFormatter